import { AnswerRepository } from "../../../../data/repository/answer/AnswerRepository";
import { Answer } from "../../../model/Question";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAnswerByQuestionIdUseCase {
  invoke: (questionId: string) => Promise<ResponseState<Answer>>;
}

export class GetAnswerByQuestionIdUseCaseImpl
  implements GetAnswerByQuestionIdUseCase
{
  private answerRepository: AnswerRepository;

  constructor(answerRepository: AnswerRepository) {
    this.answerRepository = answerRepository;
  }

  async invoke(questionId: string): Promise<ResponseState<Answer>> {
    try {
      let response = await this.answerRepository.getAnswerByQuestionId(questionId);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
